import { DropletIcon } from '@/components/icons'

export const MAX_HYDRATION_GLASSES = 8

type HydrationTrackerProps = {
  /** Number of glasses, 0–8. */
  value: number
  onChange: (value: number) => void
  disabled?: boolean
}

/**
 * Hydration counter 0–8 glasses. State is communicated by icon fill AND the
 * visible count text plus per-button accessible labels — never by color alone.
 */
export function HydrationTracker({ value, onChange, disabled = false }: HydrationTrackerProps) {
  const glasses = Array.from({ length: MAX_HYDRATION_GLASSES }, (_, i) => i + 1)

  return (
    <div className="health-section" aria-label="Hydratatie">
      <p className="hydration-count" aria-live="polite">
        {value} van {MAX_HYDRATION_GLASSES} glazen
      </p>
      <div className="hydration-grid" role="group" aria-label="Aantal glazen water">
        {glasses.map((glass) => {
          const filled = glass <= value
          return (
            <button
              key={glass}
              type="button"
              className={filled ? 'droplet-btn droplet-btn--filled' : 'droplet-btn'}
              aria-pressed={filled}
              aria-label={`Glas ${glass} ${filled ? 'gedronken' : 'niet gedronken'}`}
              disabled={disabled}
              onClick={() => onChange(glass === value ? glass - 1 : glass)}
            >
              <DropletIcon size={20} className="droplet-icon" />
            </button>
          )
        })}
      </div>
      <p className="health-hint">Tik op een glas om je hydratatie bij te werken.</p>
    </div>
  )
}
